import React from 'react'
import styled from 'styled-components'
import Colors from 'styles/Colors'
import media from 'styles/media'
import { HeadlineM, HeadlineS, Overline } from 'components/Text'
import { Paragraph } from 'components/richTextOptions'

const Calibrate: React.FC<{}> = () => {
  return (
    <Wrapper>
      <List>
        <Item>
          <Subtitle>Calibrate</Subtitle>
          <Label bullet>Automates setup and configuration.</Label>
          <Label bullet>
            Configures both intrinsic and extrinsic parameters.
          </Label>
          <Label bullet>Optimizes camera placement to reduce occlusions.</Label>
        </Item>
        <Item>
          <Subtitle>Monitor</Subtitle>
          <Label bullet>Configures high-resolution areas to monitor.</Label>
          <Label bullet>
            Configures both intrinsic and extrinsic parameters.
          </Label>
          <Label bullet>
            Validates if pick or place location is collision free.
          </Label>
        </Item>
        <Item>
          <Subtitle>Detect</Subtitle>
          <Label bullet>Adjusts automatically to variable objects.</Label>
          <Label bullet>Locates known objects in 3D space.</Label>
          <Label bullet>
            Provides collision avoidance for unexpected intrusions into a
            workcell.
          </Label>
        </Item>
      </List>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 548px;
  padding-top: 112px;
  position: relative;
  min-height: 548px;
  ${media.tablet} {
    background: ${Colors.whiteSmoke};
    height: 264px;
    padding-top: 48px;
    min-height: 900px;
  }
  ${media.mobile} {
    height: 414px;
  }
`
const List = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 80%;
  margin-left: 96px;
  list-style-type: none;
  justify-content: space-between;
  @media screen and (max-width: 1255px) {
    justify-content: flex-start;
  }
  ${media.tabletLandscape} {
    margin-left: 72px;
    width: 780px;
  }
  ${media.tablet} {
    margin-left: 48px;
  }
  ${media.mobile} {
    margin-left: 12px;
    display: block;
    max-width: calc(100% - 24px);
  }
`

const Item = styled.span`
  width: 25%;
  font-size: 24px;
  text-transform: none;
  display: block;
  position: relative;
  &:nth-child(1),
  &:nth-child(2) {
    margin-bottom: 144px;
  }
  box-sizing: content-box;
  @media screen and (max-width: 1255px) {
    &:nth-child(odd) {
      margin-right: 60px;
    }
  }
  ${media.tabletLandscape} {
    font-size: 16px;
    width: 284px;
    &:nth-child(1),
    &:nth-child(2) {
      margin-bottom: 58px;
    }
    ::after {
      font-size: 16px;
    }
  }
  ${media.tablet} {
    color: white;
    font-weight: bold;
  }
  ${media.mobile} {
    margin-bottom: 48px;
    &:nth-child(1),
    &:nth-child(2) {
      margin-bottom: 48px;
    }
    &:nth-child(odd) {
      margin-right: 0;
    }
    max-width: 329px;
    width: unset;
  }
`
const Title = styled(HeadlineM)`
  margin-left: 96px;
  margin-bottom: 99px;
  ${media.tabletLandscape} {
    font-size: 54px;
  }
  ${media.mobile} {
    font-size: 36px;
    margin-top: 15px;
    margin-left: 12px;
  }
`

const Subtitle = styled(HeadlineS)`
  margin-bottom: 24px;
  font-family: 'Maison Neue';
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: 0.0015em;
`

const Label = styled(Overline)`
  color: black;
  margin-bottom: 1vw;
  text-transform: none;
  font-size: 16px;
  line-height: 24px;
  ::after {
    color: ${Colors.neptune};
    top: 0;
  }
  ${media.fullWidth} {
    font-size: 0.8vw;
  }
`

export default Calibrate
